<template>
  <pop-up-window
    :show="this.$store.state.displayEditGeneral"
    :showClose="false"
    @close="close"
    class="doc-statuses-popup"
    fixed
  >
    <template #header>Edit General</template>
    <template #content>
      <div class="flex flex-row flex-nowrap">
        <div class="flex flex-col w-1/2 mr-12">
          <Field
            id="supplierGroupId"
            title="Supplier Group ID:"
            :modelValue="supplierGroup.supplierGroupId"
            :disabled="true"
            type="text"
          />
          <Field
            id="brandingId"
            title="Branding ID: *"
            v-model="formData.brandingId"
            :hasError="validationError.brandingId"
            @focusout="validationError.brandingId = false"
            type="text"
          />
          <span v-if="validationError.brandingId" class="text-primary-3"
            >Branding id is required</span
          >
          <div class="mb-3">
            <label for="editType" class="font-bold form-label">Type: *</label>
            <Dropdown
              id="editType"
              @update-value="updateSelectedType"
              :data="typeData"
              :selected="formData.sgType"
              :disabled="false"
            />
          </div>
          <div>
            <Field
              :hasError="validationError.name"
              id="name"
              title="Name: *"
              @focusout="validationError.name = false"
              v-model="formData.name"
              type="text"
            />
            <span v-if="validationError.name" class="text-primary-3"
              >Name is Required</span
            >
          </div>

          <div>
            <p class="font-bold">Project Status:</p>
            <Dropdown
              :data="optionStatuses"
              :selected="status.projectStatus"
              @update-value="updateProjectStatus"
              class="mb-3"
            />
            <div class="flex flex-row">
              <p class="font-bold mr-2">Is Delinquent payer:</p>
              <ToggleSlide
                class="w-min"
                @update-value="
                  status.isDelinquentPayer = !status.isDelinquentPayer
                "
                :bool="status.isDelinquentPayer"
                :renew-bool="true"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-col w-1/2">
          <Field
            :hasError="validationError.portalLink"
            id="portalLink"
            title="Portal Link: *"
            placeholder="https://example.com"
            v-model="formData.portalLink"
            @focusout="validationError.portalLink = false"
            type="text"
          />
          <span v-if="validationError.portalLink" class="text-primary-3"
            >Portal link must be a valid URL</span
          >
          <Field
            :hasError="validationError.idpUrlInvalid"
            id="idpUrl"
            title="IDP url"
            placeholder="https://example.com"
            v-model="formData.idpUrl"
            @focusout="validationError.idpUrlInvalid = false"
            type="text"
          />
          <span v-if="validationError.idpUrlInvalid" class="text-primary-3"
            >IDP url must be a valid URL</span
          >
          <Field
            id="tacEmail"
            title="Terms and Conditions Email:"
            v-model="formData.termsOfServiceEmail"
            type="text"
          />
          <div class="mb-3">
            <label for="editLanguages" class="font-bold form-label"
              >Languages: *</label
            >
            <DropdownSelectAll
              id="editLanguages"
              :class="{ 'border border-primary-3': validationError.languages }"
              @update-value="updateSelectedLanguages"
              :data="languages"
              :selected="formData.languages"
              :disabled="false"
              :noSelectAll="true"
              @focusout="validationError.languages = false"
            />

            <span v-if="validationError.languages" class="text-primary-3"
              >Select at least 1 language</span
            >
          </div>
        </div>
      </div>
      <div class="grid grid-rows-1 justify-items-end">
        <div>
          <button class="btn shadow-md mr-2" @click="update">Update</button>
          <button
            class="btn shadow-md mr-2 nymus-orange color-white"
            @click="close"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </pop-up-window>

  <pop-up-window
    :show="this.didBrandingIdChange"
    :showClose="false"
    @close="closeWarningRealm('branding')"
    class="doc-statuses-popup"
    width20
    top10
  >
    <template #header>Changed Realm</template>
    <template #content>
      <div style="text-align: center">
        <p>You changed your Branding ID</p>
        <p>Don't forget to change the realm!</p>
        <button
          class="btn shadow-md mr-2 nymus-orange color-white"
          style="margin-top: 10px"
          @click="closeWarningRealm('branding')"
        >
          Okay
        </button>
      </div>
    </template>
  </pop-up-window>
  <pop-up-window
    :show="this.didPortalLinkChange"
    :showClose="false"
    @close="closeWarningRealm('portalLink')"
    class="doc-statuses-popup"
    width20
    top10
  >
    <template #header>Changed Realm</template>
    <template #content>
      <div style="text-align: center">
        <p>You changed your Portal Link</p>
        <p>Don't forget to change the webhook in Postmark!</p>
        <button
          class="btn shadow-md mr-2 nymus-orange color-white"
          style="margin-top: 10px"
          @click="closeWarningRealm('portalLink')"
        >
          Okay
        </button>
      </div>
    </template>
  </pop-up-window>
</template>

<script>
import PopUpWindow from "../PopUp.vue";
import Field from "../Field.vue";
import Dropdown from "../Dropdown.vue";
import DropdownSelectAll from "../DropdownSelectAll.vue";
import ToggleSlide from "@/components/ToggleSlide.vue";

export default {
  name: "EditGeneral",
  components: {
    ToggleSlide,
    PopUpWindow,
    Field,
    Dropdown,
    DropdownSelectAll,
  },
  props: {
    languages: Array,
    typeData: Array,
  },
  mounted() {
    this.initData();
  },
  data() {
    return {
      supplierGroup: {},
      originalBrandingId: "",
      originalPortalLink: "",
      formData: {},
      status: {},
      didBrandingIdChange: false,
      didPortalLinkChange: false,
      validationError: {
        name: false,
        brandingId: false,
        portalLink: false,
        idpUrl: false,
        languages: false,
      },
      validationRules: {
        name: (value) => value === "" || value === undefined,
        brandingId: (value) => value === "" || value === undefined,
        portalLink: (value) =>
          value === "" || !this.$store.state.urlRegex.test(value),
        idpUrl: (value) =>
          value === "" || !this.$store.state.urlRegex.test(value),
        languages: (value) => value.length === 0,
      },
    };
  },
  watch: {
    "$store.state.activeSG": {
      handler() {
        this.initData();
      },
    },
  },
  computed: {
    optionStatuses() {
      let statuses = this.$store.state.statusesSG.map((status) => {
        return { name: status.status };
      });

      if (statuses[statuses.length - 1].name === "NOT_PAID") statuses.pop();
      return statuses;
    },
  },
  methods: {
    initData() {
      this.supplierGroup = this.$store.state.activeSG;
      this.originalBrandingId = this.supplierGroup.brandingId;
      this.originalPortalLink =
        this.supplierGroup.channelsConfig.docImage.configPortal.portalLink;

      this.formData.brandingId = this.supplierGroup.brandingId;
      this.formData.sgType = this.supplierGroup.sgType;
      this.formData.name = this.supplierGroup.name;
      this.formData.portalLink =
        this.supplierGroup.channelsConfig.docImage.configPortal.portalLink;
      this.formData.idpUrl =
        this.supplierGroup.channelsConfig.docImage.configPortal.idpUrl;
      this.formData.termsOfServiceEmail =
        this.supplierGroup.channelsConfig.docImage.configPortal.termsOfServiceEmail;
      this.formData.languages =
        this.supplierGroup.languages !== undefined
          ? this.supplierGroup.languages
          : [];
      this.status = {
        projectStatus: this.supplierGroup.status?.projectStatus
          ? this.supplierGroup.status.projectStatus
          : "CREATED",
        isDelinquentPayer: this.supplierGroup.status?.isDelinquentPayer
          ? this.supplierGroup.status.isDelinquentPayer
          : false,
      };
      this.setAllErrorsFalse();
    },
    setAllErrorsFalse() {
      Object.keys(this.validationError).forEach((key) => {
        this.validationError[key] = false;
      });
    },
    updateSelectedType(data) {
      if (this.typeData[data]) {
        this.formData.sgType = this.typeData[data].name;
      }
    },
    updateSelectedLanguages(data) {
      this.formData.languages = [];
      for (let item of data) {
        this.formData.languages.push(this.languages[item].name);
      }
    },
    updateProjectStatus(e) {
      if (typeof e === "object") e = e[0];
      if (e < 0) return;
      this.status.projectStatus = this.optionStatuses[e].name;
    },
    close() {
      this.initData();
      this.$store.state.displayEditGeneral = false;
    },
    closeWarningRealm(type) {
      if (type === "branding") this.didBrandingIdChange = false;
      else if (type === "portalLink") this.didPortalLinkChange = false;
    },
    async update() {
      if (!this.validate()) {
        //save general information
        if (this.formData.termsOfServiceEmail === "") {
          delete this.formData.termsOfServiceEmail;
        }

        this.didBrandingIdChange =
          this.originalBrandingId !== this.formData.brandingId;
        this.didPortalLinkChange =
          this.originalPortalLink !== this.formData.portalLink;

        let payload = {
          sgId: this.supplierGroup.supplierGroupId,
          edit: "info",
          body: this.formData,
        };
        let payloadStatus = {
          sgId: this.supplierGroup.supplierGroupId,
          status: { ...this.status },
        };

        await this.$store.dispatch("EditSupplierGroup", payload);
        if (this.$store.state.responseStatus === 200) {
          this.$store.commit("toggleAlert", {
            title: "Edit SupplierGroup",
            text: "General successfully edited",
          });
        }

        // save SG status
        try {
          await this.$store.dispatch(
            "EditSettingsSupplierGroup",
            payloadStatus,
          );
          if (this.$store.state.responseStatus === 200) {
            this.$store.commit("toggleAlert", {
              title: "Edit SupplierGroup status",
              text: "Status successfully edited",
            });
          }
        } catch (e) {
          this.$store.commit("displayErrorAlert", true);
          this.$store.commit("setErrorAlertText", e.message);
        }

        this.close();
      }
    },
    validate() {
      this.setAllErrorsFalse();
      let hasError = false;

      Object.keys(this.validationRules).forEach((field) => {
        if (this.validationRules[field](this.formData[field])) {
          this.validationError[field] = true;
        }

        hasError = Object.values(this.validationError).some((v) => v === true);
      });

      return hasError;
    },
  },
};
</script>
